import api from "./api";
import { PaymentType } from "../components/ReceiptsPayment/receiptsType";
export type DeletePaymentsDto = {
  id: number | string;
};

const sessionId = localStorage.getItem("sessionId");

const returnCompleteDto = (Dto: PaymentType) => {
  return { ...Dto, sessionId: sessionId };
};

export const getReceipts = async (limit: number, from: string, to: string) => {
  return await api.get(`receipts?limit=${limit}&from=${from}&to=${to}`);
};

export const deletePayments = async (dto: DeletePaymentsDto) => {
  return await api.delete(`/receipts/${dto.id}`);
};

export const getPaymentsById = async (paymentId: string | undefined) => {
  return await api.get(`/receipts/${paymentId}`);
};

export const editPayments = async (paymentId: any, body: PaymentType) => {
  return await api.put(`/receipts/${paymentId}`, body);
};

export const createPayments = async (paymentId: PaymentType) => {
  return await api.post("/receipts", paymentId);
};

export const getSalesDropdown = async (customerId: number) => {
  return await api.get(`/sales/dropdown/${customerId}`);
};

export const getSalesNullDropdown = async () => {
  return await api.get(`/sales/dropdown`);
};
export const getCustomerDropdownFiltered = async (hasSale: boolean) => {
  return await api.get(`/customers/dropdown?hasSale=${hasSale}`);
};

export const getCustomersReceipts = async (customersId: string | undefined) => {
  return await api.get(`/receipts/customers/${customersId}`);
};
